// extracted by mini-css-extract-plugin
export default {"yandexLoginButton":"styles_yandexLoginButton__QLjR9"};